// Authentic supplications for the journey. Each entry: Arabic, transliteration,
// English & French translation, optional "when" (ritual/location) label, and source.
// Qur'anic verses and well-established Prophetic du'as only — nothing invented.

export const DUA_CATEGORIES = [
  {
    id: "journey",
    title: { en: "Journey & Rites", fr: "Voyage et rites" },
    duas: [
      {
        id: "talbiyah",
        when: { en: "In Ihram, repeated often", fr: "En état d'Ihram, répétée souvent" },
        arabic: "لَبَّيْكَ اللَّهُمَّ لَبَّيْكَ، لَبَّيْكَ لَا شَرِيكَ لَكَ لَبَّيْكَ، إِنَّ الْحَمْدَ وَالنِّعْمَةَ لَكَ وَالْمُلْكَ، لَا شَرِيكَ لَكَ",
        translit: "Labbayk Allahumma labbayk, labbayka la sharika laka labbayk, innal-hamda wan-ni'mata laka wal-mulk, la sharika lak.",
        translation: {
          en: "Here I am, O Allah, here I am. Here I am, You have no partner, here I am. Truly all praise, favour and sovereignty are Yours; You have no partner.",
          fr: "Me voici, ô Allah, me voici. Me voici, Tu n'as pas d'associé, me voici. Certes, toute louange, grâce et souveraineté T'appartiennent ; Tu n'as pas d'associé.",
        },
        source: "Bukhari 1549 · Muslim 1184",
      },
      {
        id: "enter-masjid",
        when: { en: "Entering the mosque", fr: "En entrant dans la mosquée" },
        arabic: "اللَّهُمَّ افْتَحْ لِي أَبْوَابَ رَحْمَتِكَ",
        translit: "Allahumma-aftah li abwaba rahmatik.",
        translation: {
          en: "O Allah, open for me the gates of Your mercy.",
          fr: "Ô Allah, ouvre-moi les portes de Ta miséricorde.",
        },
        source: "Muslim 713",
      },
      {
        id: "leave-masjid",
        when: { en: "Leaving the mosque", fr: "En quittant la mosquée" },
        arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ مِنْ فَضْلِكَ",
        translit: "Allahumma inni as'aluka min fadlik.",
        translation: {
          en: "O Allah, I ask You of Your bounty.",
          fr: "Ô Allah, je Te demande de Ta grâce.",
        },
        source: "Muslim 713",
      },
      {
        id: "black-stone",
        when: { en: "Facing the Black Stone to begin each circuit", fr: "Face à la Pierre noire au début de chaque circuit" },
        arabic: "بِسْمِ اللَّهِ وَاللَّهُ أَكْبَرُ",
        translit: "Bismillah, wallahu akbar.",
        translation: {
          en: "In the name of Allah; Allah is the Greatest. (Point toward the Black Stone if you cannot reach it.)",
          fr: "Au nom d'Allah ; Allah est le Plus Grand. (Pointez vers la Pierre noire si vous ne pouvez l'atteindre.)",
        },
        source: "Bukhari 1613",
      },
      {
        id: "between-corners",
        when: { en: "Between the Yemeni Corner and the Black Stone", fr: "Entre le Coin yéménite et la Pierre noire" },
        arabic: "رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الْآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ",
        translit: "Rabbana atina fid-dunya hasanatan wa fil-akhirati hasanatan wa qina 'adhaban-nar.",
        translation: {
          en: "Our Lord, grant us good in this world and good in the Hereafter, and protect us from the punishment of the Fire.",
          fr: "Notre Seigneur, accorde-nous un bien dans ce monde et un bien dans l'au-delà, et protège-nous du châtiment du Feu.",
        },
        source: "Qur'an 2:201 · Abu Dawud 1892",
      },
      {
        id: "safa-marwah",
        when: { en: "On Safa and Marwah", fr: "Sur Safa et Marwa" },
        arabic: "لَا إِلَٰهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
        translit: "La ilaha illallahu wahdahu la sharika lah, lahul-mulku wa lahul-hamd, wa huwa 'ala kulli shay'in qadir.",
        translation: {
          en: "There is no god but Allah alone, without partner. His is the dominion and His is all praise, and He has power over all things.",
          fr: "Il n'y a de divinité qu'Allah, Seul, sans associé. À Lui la royauté et à Lui la louange, et Il est capable de toute chose.",
        },
        source: "Muslim 1218",
      },
      {
        id: "no-prescribed",
        when: { en: "During Tawaf & Sa'i", fr: "Pendant le Tawaf et le Sa'i" },
        arabic: "",
        translit: "",
        translation: {
          en: "There is no specific du'a prescribed for each circuit. Call upon Allah for whatever good you wish, in any language, with a present heart.",
          fr: "Aucune du'a précise n'est prescrite pour chaque circuit. Invoquez Allah pour tout bien que vous souhaitez, dans n'importe quelle langue, avec un cœur présent.",
        },
        source: "",
      },
    ],
  },
  {
    id: "forgiveness",
    title: { en: "Forgiveness & Guidance", fr: "Pardon et guidée" },
    duas: [
      {
        id: "sayyid-istighfar",
        when: { en: "Master supplication for forgiveness", fr: "La meilleure demande de pardon" },
        arabic: "اللَّهُمَّ أَنْتَ رَبِّي لَا إِلَٰهَ إِلَّا أَنْتَ، خَلَقْتَنِي وَأَنَا عَبْدُكَ، وَأَنَا عَلَى عَهْدِكَ وَوَعْدِكَ مَا اسْتَطَعْتُ، أَعُوذُ بِكَ مِنْ شَرِّ مَا صَنَعْتُ، أَبُوءُ لَكَ بِنِعْمَتِكَ عَلَيَّ، وَأَبُوءُ بِذَنْبِي فَاغْفِرْ لِي فَإِنَّهُ لَا يَغْفِرُ الذُّنُوبَ إِلَّا أَنْتَ",
        translit: "Allahumma anta Rabbi la ilaha illa anta, khalaqtani wa ana 'abduk, wa ana 'ala 'ahdika wa wa'dika mastata't, a'udhu bika min sharri ma sana't, abu'u laka bi ni'matika 'alayy, wa abu'u bi dhanbi faghfir li fa innahu la yaghfirudh-dhunuba illa ant.",
        translation: {
          en: "O Allah, You are my Lord; there is no god but You. You created me and I am Your servant, and I hold to Your covenant as best I can. I seek refuge in You from the evil I have done. I acknowledge Your favour upon me and I confess my sin, so forgive me, for none forgives sins but You.",
          fr: "Ô Allah, Tu es mon Seigneur ; il n'y a de divinité que Toi. Tu m'as créé et je suis Ton serviteur, et je reste fidèle à Ton pacte autant que je peux. Je cherche refuge auprès de Toi contre le mal que j'ai commis. Je reconnais Tes bienfaits et je confesse mon péché ; pardonne-moi, car nul ne pardonne les péchés sauf Toi.",
        },
        source: "Bukhari 6306",
      },
      {
        id: "rabbana-zalamna",
        arabic: "رَبَّنَا ظَلَمْنَا أَنْفُسَنَا وَإِنْ لَمْ تَغْفِرْ لَنَا وَتَرْحَمْنَا لَنَكُونَنَّ مِنَ الْخَاسِرِينَ",
        translit: "Rabbana zalamna anfusana wa in lam taghfir lana wa tarhamna lanakunanna minal-khasirin.",
        translation: {
          en: "Our Lord, we have wronged ourselves, and if You do not forgive us and have mercy upon us, we will surely be among the losers.",
          fr: "Notre Seigneur, nous nous sommes fait du tort à nous-mêmes ; si Tu ne nous pardonnes pas et ne nous fais pas miséricorde, nous serons certes parmi les perdants.",
        },
        source: "Qur'an 7:23",
      },
      {
        id: "rabbana-la-tuzigh",
        arabic: "رَبَّنَا لَا تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا وَهَبْ لَنَا مِنْ لَدُنْكَ رَحْمَةً إِنَّكَ أَنْتَ الْوَهَّابُ",
        translit: "Rabbana la tuzigh qulubana ba'da idh hadaytana wa hab lana min ladunka rahmah, innaka antal-Wahhab.",
        translation: {
          en: "Our Lord, let not our hearts deviate after You have guided us, and grant us mercy from Yourself. Truly You are the Bestower.",
          fr: "Notre Seigneur, ne laisse pas dévier nos cœurs après que Tu nous as guidés, et accorde-nous une miséricorde venant de Toi. Certes, Tu es le Grand Donateur.",
        },
        source: "Qur'an 3:8",
      },
    ],
  },
  {
    id: "family",
    title: { en: "Parents & Family", fr: "Parents et famille" },
    duas: [
      {
        id: "parents",
        arabic: "رَبِّ ارْحَمْهُمَا كَمَا رَبَّيَانِي صَغِيرًا",
        translit: "Rabbi-rhamhuma kama rabbayani saghira.",
        translation: {
          en: "My Lord, have mercy upon them as they raised me when I was small.",
          fr: "Mon Seigneur, fais-leur miséricorde comme ils m'ont élevé tout petit.",
        },
        source: "Qur'an 17:24",
      },
      {
        id: "family-comfort",
        arabic: "رَبَّنَا هَبْ لَنَا مِنْ أَزْوَاجِنَا وَذُرِّيَّاتِنَا قُرَّةَ أَعْيُنٍ وَاجْعَلْنَا لِلْمُتَّقِينَ إِمَامًا",
        translit: "Rabbana hab lana min azwajina wa dhurriyyatina qurrata a'yunin waj'alna lil-muttaqina imama.",
        translation: {
          en: "Our Lord, grant us from among our spouses and offspring comfort to our eyes, and make us a leader for the righteous.",
          fr: "Notre Seigneur, accorde-nous, de nos épouses et de nos descendants, la joie des yeux, et fais de nous un guide pour les pieux.",
        },
        source: "Qur'an 25:74",
      },
    ],
  },
  {
    id: "protection",
    title: { en: "Protection & Well-being", fr: "Protection et bien-être" },
    duas: [
      {
        id: "afiyah",
        arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي الدُّنْيَا وَالْآخِرَةِ",
        translit: "Allahumma inni as'alukal-'afwa wal-'afiyata fid-dunya wal-akhirah.",
        translation: {
          en: "O Allah, I ask You for pardon and well-being in this world and the Hereafter.",
          fr: "Ô Allah, je Te demande le pardon et le bien-être dans ce monde et dans l'au-delà.",
        },
        source: "Ibn Majah 3871",
      },
      {
        id: "harm-protection",
        when: { en: "Morning & evening, for protection", fr: "Matin et soir, pour la protection" },
        arabic: "بِسْمِ اللَّهِ الَّذِي لَا يَضُرُّ مَعَ اسْمِهِ شَيْءٌ فِي الْأَرْضِ وَلَا فِي السَّمَاءِ وَهُوَ السَّمِيعُ الْعَلِيمُ",
        translit: "Bismillahilladhi la yadurru ma'asmihi shay'un fil-ardi wa la fis-sama'i wa huwas-Sami'ul-'Alim.",
        translation: {
          en: "In the name of Allah, with whose name nothing on earth or in heaven can cause harm, and He is the All-Hearing, the All-Knowing.",
          fr: "Au nom d'Allah, avec le nom duquel rien sur terre ni au ciel ne peut nuire, et Il est l'Audient, l'Omniscient.",
        },
        source: "Abu Dawud 5088 · Tirmidhi 3388",
      },
    ],
  },
  {
    id: "general",
    title: { en: "Good in Both Worlds", fr: "Bien dans les deux mondes" },
    duas: [
      {
        id: "huda-tuqa",
        arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْهُدَى وَالتُّقَى وَالْعَفَافَ وَالْغِنَى",
        translit: "Allahumma inni as'alukal-huda wat-tuqa wal-'afafa wal-ghina.",
        translation: {
          en: "O Allah, I ask You for guidance, piety, chastity and self-sufficiency.",
          fr: "Ô Allah, je Te demande la guidée, la piété, la chasteté et la richesse (du cœur).",
        },
        source: "Muslim 2721",
      },
      {
        id: "dhikr-shukr",
        when: { en: "After every prayer", fr: "Après chaque prière" },
        arabic: "اللَّهُمَّ أَعِنِّي عَلَى ذِكْرِكَ وَشُكْرِكَ وَحُسْنِ عِبَادَتِكَ",
        translit: "Allahumma a'inni 'ala dhikrika wa shukrika wa husni 'ibadatik.",
        translation: {
          en: "O Allah, help me to remember You, to thank You, and to worship You well.",
          fr: "Ô Allah, aide-moi à T'évoquer, à Te remercier et à bien T'adorer.",
        },
        source: "Abu Dawud 1522",
      },
    ],
  },
];
